export const PINNED_MODEL = "z-ai/glm-4.7";
